import { RejectForm } from '@/modules/Dayoffs/components/Form/RejectForm'
import { DayOffResponse } from '@/modules/Dayoffs/types/response'
import { ModalProps } from '@/types/shared'
import { Dialog } from 'vnetwork-ui'

export interface RejectModalProps extends ModalProps {
    dayOff: DayOffResponse
    refetch: () => void
}

const RejectModal: React.FC<RejectModalProps> = ({
    onClose,
    open,
    dayOff,
    refetch,
}) => {
    return (
        <Dialog onClose={onClose} open={open} title={'Leader Confirm'}>
            <RejectForm dayOff={dayOff} refetch={refetch} onClose={onClose} />
        </Dialog>
    )
}

export default RejectModal
